// src/jsx/components/CandidateScoresReportCell.jsx
import React from 'react';
import PropTypes from 'prop-types';

export const ScoreCell = ({ value }) => {
  if (value === null || value === undefined || value === '') {
    return <span className="text-muted">-</span>;
  }
  return <span>{value}</span>;
};

export const AverageScoreCell = ({ value }) => {
  if (value === null || value === undefined || value === '') {
    return <span className="text-muted">-</span>;
  }

  const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
  return <span className="fw-bold text-primary">{formattedValue}</span>;
};

export const CommentsCell = ({ value }) => {
  if (!value || value.trim() === '') {
    return <span className="text-muted" />;
  }

  // Split by newlines and render each line as a separate element
  const lines = value.split('\n');

  return (
    <div className="comments-cell">
      {lines.map((line, index) => (
        <div key={index}>
          {line || '\u00A0'} {/* Non-breaking space for empty lines */}
        </div>
      ))}
    </div>
  );
};

export const CompletionStatus = ({ value }) =>
  value ? (
    <span className="badge bg-success">Complete</span>
  ) : (
    <span className="badge bg-warning text-dark">Incomplete</span>
  );

ScoreCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AverageScoreCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CommentsCell.propTypes = {
  value: PropTypes.string,
};

CompletionStatus.propTypes = {
  value: PropTypes.bool.isRequired,
};
